/**
 * Internal bridge for shared services that must dismiss an app shell overlay
 * without depending on student/staff BlockUIService types.
 * Not exported from public-api.ts.
 */
export const STUDENT_BLOCK_UI_REGISTRY_KEY = '__studentBlockUiBox';
const STAFF_BLOCK_UI_REGISTRY_KEY = '__staffBlockUiBox';

function resolveRegisteredBox(): any {
  const win = window as any;
  return win[STUDENT_BLOCK_UI_REGISTRY_KEY] ?? win[STAFF_BLOCK_UI_REGISTRY_KEY] ?? null;
}

export function showRegisteredAppBlockUi(): void {
  const box = resolveRegisteredBox();
  box?.open?.();
}

export function hideRegisteredAppBlockUi(): void {
  const box = resolveRegisteredBox();
  box?.close?.();
}
